import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutEcshopAccountsRequestModel, PutEcshopAccountsResponseModel } from "@/features/accounts/ecshop/services/put-accounts-model";

export class PutEcshopAccountsApi {
  /**
   * その他連携サービス口座更新API
   */
  public putEcshopAccounts = async (
    param: PutEcshopAccountsRequestModel
  ): Promise<PutEcshopAccountsResponseModel> => {
    const path = `/api/ecshopaccounts/ecshops`;
    const res = await ApiClient.instance.put<PutEcshopAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
